export default {
  install(Vue) {
    Vue.prototype.$debounce = (fn, delay) => {
      let timer = null;

      const debounced = function(...args) {
        const callback = () => {
          timer = null;

          fn.apply(this, args);
        };

        clearTimeout(timer);
        timer = setTimeout(callback, delay);

        if (!timer) {
          fn.apply(this, args);
        }
      };

      debounced.cancel = () => {
        clearTimeout(timer);
        timer = null;
      };

      return debounced;
    };
  }
};
